module.exports = __webpack_public_path__ + "media/images/footer/pl_efs-769ee2f082a17891889a500131ec07a6.svg";